export default "<app-order-detail></app-order-detail>"